import script from "./UserList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=7741c34d&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7741c34d"]])

export default __exports__